export const shop = [
  {
    bindTime: "2023-01-08 10:00:45",
    index: 1437705573926703104,
    platform: "拼多多",
    shopName: "寻星折扣店",
  },
];
